@if(headerConfig()){
    <lsa-header [headerConfig]="headerConfig()!"></lsa-header>
}@else {
    <div class="head-spacer"></div>
}
@for (section of sections(); track $index) {
    <lsa-section-renderer [sectionConfig]="section"></lsa-section-renderer>
}
@if(pageFooterOptions()?.show){
    <lsa-footer [backgroundColor]="pageFooterOptions()?.backgroundColor" [textColor]="pageFooterOptions()?.textColor" [config]="footerConfig()!"></lsa-footer>
}